export interface Archive{
  id: number,
  type: ArchiveType,
  name: string,
  created_at: Date,
  created_by: string,
  archived_at: Date,
  archived_by: string,
  preview: string
}

export enum ArchiveType{
  Project = 'projects',
  User = 'users',
  Client = 'clients',
  Questions = 'questions',
  Degrees = 'degrees',
  ProjectRoles = 'projectroles',
  Seniorities = 'seniorities',
  Departments = 'departments',
  Development = 'developments',
  Skills = 'skills',
  SkillCategories = 'skill-categories',
  Certifications = 'certifications'
}
